import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const VIMEOPLAYERBLOCK_LEGACY_FIELD_ORDER = [
  "video_id"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  vimeoPlayerBlockDescriptor: _generatedVimeoPlayerBlockDescriptor,
  vimeoPlayerBlockBlocDefinition,
  vimeoPlayerBlockDashboardLayout,
  vimeoPlayerBlockConfig,
  vimeoPlayerBlockResolveConfig,
  vimeoPlayerBlockProperties,
} = doodBlockConfig(
  {
    name: "Video - Vimeo player",
    componentType: 'VimeoPlayerBlockComponent',
    category: 'media',
    description: "Video - Vimeo player.",
    keywords: [],
    sharedFields: {}
  },

  () => ({
    video_id: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.vimeo-player.video-id.label",
        help: "pages.blocks.vimeo-player.video-id.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.vimeo-player.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.vimeo-player.fieldset.video.label",
            fields: ["video_id"],
          },
        ],
      },
    ],
  })
);

export function vimeoPlayerBlockDescriptor(): IBlockDescriptor;
export function vimeoPlayerBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function vimeoPlayerBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedVimeoPlayerBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedVimeoPlayerBlockDescriptor, vimeoPlayerBlockProperties, fieldOrder);
}

export {
  vimeoPlayerBlockBlocDefinition,
  vimeoPlayerBlockDashboardLayout,
  vimeoPlayerBlockProperties,
  vimeoPlayerBlockConfig,
  vimeoPlayerBlockResolveConfig,
};

export type VimeoPlayerBlockConfig = typeof vimeoPlayerBlockConfig;
